import React from "react";
import Proptypes from "prop-types";
import { Flex, Text, Link, Box, Button } from "@chakra-ui/react";
import Logo from "../Common/LogoComponent";
import Info from "../Common/Info";
const Header = ({ handleOnClick, type }) => {
  return (
    <header>
      <Info>
        <Text fontSize="sm">
          You can capture form submissions directly to your{" "}
          <Link
            color="#2C5CC5"
            href="https://www.freshworks.com/crm/suite/"
            target="_blank"
            fontWeight="600"
          >
            Freshsales Suite
          </Link>{" "}
          account by installing Freshworks CRM plugin.<span>{"   "} </span> Dont
          have an account?{" "}
          <Link
            color="#2C5CC5"
            href="https://www.freshworks.com/crm/signup/?plan_id=suite&utm_source=wordpress_plugin"
            target="_blank"
            fontWeight="600"
          >
            Signup
          </Link>
        </Text>
      </Info>

      <Box>
        <Flex
          style={{
            paddingTop: "16px",
            paddingBottom: "6px",
            /* align-items: center; */
            paddingLeft: "16px",
          }}
        >
          <Logo style={{ marginTop: "20px" }} />
          <Text ml="2" color="#12344D" fontWeight="600" fontSize="18px">
            Freshworks forms{" "}
          </Text>
        </Flex>
      </Box>
      <Box p="2" bg="#fff">
        <Flex align="center">
          {type == "entries" ? (
            <Text ml="2" color="#12344D">
              Entries
            </Text>
          ) : (
            <>
              <Text ml="2" color="#12344D" fontSize="18px" fontWeight="600">
                Forms Overview
              </Text>
              <Button
                ml="3"
                colorScheme="primary"
                className="btn--primary"
                size="sm"
                onClick={handleOnClick}
              >
                Add Form
              </Button>
            </>
          )}
        </Flex>
      </Box>
    </header>
  );
};

Header.defaultProps = {
  type: "forms",
};

Header.propTypes = {
  handleOnClick: Proptypes.func.isRequired,
};
export default Header;
